import { fetchUserManagementList } from "../../app/redux/slices/userManagement/userManagementSlice";
import { authAxios } from "../config";
import { ApiKey } from "../endpoints";

export const fetchUserManagementListReq = async () => {
  try {
    const res = await authAxios.post(`${ApiKey.testingUrl}`);
    const _data = res.data;
    return {
      error: false,
      data: _data,
      message: "",
      errorMsg: "",
    };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const fetchUserByIdReq = async (userId) => {
  try {
    const res = await authAxios.get(
      `${ApiKey.getUserManagementListbyId}/${userId}`
    );

    const _data = res?.data[0];

    return { error: false, data: _data, message: "", errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const addNewUserManagementReq = async (data) => {
  try {
    const res = await authAxios.post(`${ApiKey.addUserManagementKey}`, data);
    return res;
    const msg = res.data.message;
    const _data = res.data;
    return { error: false, data: _data, message: msg, errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
export const updateUserManagementReq = async (data, dispatch) => {
  try {
    const res = await authAxios.post(`${ApiKey.updateUserManagementKey}`, data);

    const msg = res?.data?.message;
    const _data = res?.data;
    dispatch(fetchUserManagementList());
    return { error: false, data: _data, message: msg, errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const deleteUserManagementReq = async (userId) => {
  try {
    const res = await authAxios.delete(
      `${ApiKey.deleteUserManagementKey}${userId}`
    );

    const msg = res.data?.message;
    const _data = res.data;
    return { error: false, data: _data, message: msg, errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const createAdminReq = async (data) => {
  try {
    const res = await authAxios.post(ApiKey.createAdmin, data);
    return { error: false, data: res.data };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong. Please try again later.";
    return { error: true, message: error };
  }
};

/* export const getAllUserPaginated = async (data) => {
  try {
    const res = await authAxios.post(`${ApiKey.getUsersPaginated}`, data);
    return res;
    const msg = res.data.message;
    const _data = res.data;
    return { error: false, data: _data, message: msg, errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
}; */

export const getAllUserPaginated = async (data) => {
  try {
    const res = await authAxios.post(`${ApiKey.getUsersPaginated}`, {
      CallerRoleId: data.callerRoleId,
      PageNumber: data.pageNumber,
      PageSize: data.pageSize,
      StatusFilter: data.statusFilter || "all",
      RoleFilter: data.roleFilter || "all",
      SearchTerm: data.searchTerm || "", // Empty string instead of null
    });

    return res;
  } catch (err) {
    let error;
    if (err.response) {
      console.error("API Error:", err.response.data);
      error =
        err.response.data.message || JSON.stringify(err.response.data.errors);
    } else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const DeactivateUser = async (userId) => {
  try {
    const res = await authAxios.put(`${ApiKey.deleteUser}${userId}`);

    const msg = res.data?.message;
    const _data = res.data;
    return { error: false, data: _data, message: msg, errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const ReactivateUser = async (data) => {
  debugger;
  try {
    const res = await authAxios.put(`${ApiKey.restoreUser}`, data);

    const msg = res.data?.message;
    const _data = res.data;
    return { error: false, data: _data, message: msg, errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const fetchDashboardDataCount = async () => {
  try {
    const res = await authAxios.get(`${ApiKey.DashboardCount}`);
    const _data = res.data;
    return {
      error: false,
      data: _data,
      message: "",
      errorMsg: "",
    };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
